import { render } from "./templates/support-review.html?vue&type=template&id=3fce7464&external"
import script from "./support-review.vue?vue&type=script&lang=js"
export * from "./support-review.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__